import firebase from '../firebase.js';

export const saveEndTime = (documentId, time) => {
  const ref = firebase.firestore().collection('players')

  return ref.doc(documentId).update({
    endTime: time
  })
}
//have to give access to write document since we update firebase here
export const saveOpenedHints = (hint, documentId) => {
  const playerRef = firebase.firestore().collection('players')
  
    if(hint && documentId) {
      return playerRef.doc(documentId).update({
        openedHints: firebase.firestore.FieldValue.arrayUnion(hint)
      })
    }
}
